import React from 'react';
import {observer} from 'mobx-react';
import {PredictionOddsTooltip} from "./prediction.odds.tooltip";
import {BookmakerStripLogo} from "../../../bookmaker-strip/bookmaker-strip-logo";

export const PredictionOddCell = observer(({
                                             controller,
                                             odds,
                                             isSelected,
                                             onClick,
                                             bookmaker,
                                             bookieHrefModel,
                                             betsImpressionParams
                                           }) => {
    const tooltipProps = {
      option: odds,
      controller,
      isSelected,
      onClick,
      bookieHrefModel,
      bookmaker,
      betsImpressionParams
    }

    const entityLogoProps = {
      onClick,
      bookieHrefModel,
      controller,
      bookmaker,
      logoWidth: 72,
      clickable: !!(bookieHrefModel && onClick),
      betsImpressionParams
    }

    return <>
      <PredictionOddsTooltip {...tooltipProps}/>
      <BookmakerStripLogo {...entityLogoProps}/>
    </>
  }
);
